import { render, staticRenderFns } from "./StockInTransit.vue?vue&type=template&id=11ffd83e&scoped=true&"
import script from "./StockInTransit.vue?vue&type=script&lang=js&"
export * from "./StockInTransit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ffd83e",
  null
  
)

export default component.exports